import axios from "axios";
import { API_BASE_URL, CUSTOMERS_URL } from "../../../constants/config";

const ECOM_CHAT_URL = `${API_BASE_URL}/sale/ecom-chat`;

export function fetchSessions() {
  return axios.get(`${ECOM_CHAT_URL}/sessions`);
}

export function fetchThread(sessionId) {
  return axios.get(`${ECOM_CHAT_URL}/sessions/${sessionId}/thread`);
}

export function fetchContext(sessionId) {
  return axios.get(`${ECOM_CHAT_URL}/sessions/${sessionId}/context`);
}

export function fetchShoppers() {
  return axios.get(`${ECOM_CHAT_URL}/shoppers`);
}

export function fetchAgents() {
  return axios.get(`${ECOM_CHAT_URL}/agents`);
}

export function fetchCartDetail(customerId) {
  return axios.get(`${ECOM_CHAT_URL}/customers/${customerId}/cart`);
}

export function fetchCustomerContext(customerId) {
  return axios.get(`${ECOM_CHAT_URL}/customers/${customerId}/context`);
}

export function searchCustomers(query) {
  return axios.get(`${CUSTOMERS_URL}/list2`, {
    params: {
      search_key: query,
      allow_ecom: "Y",
      is_active: 1,
      page: 1,
      page_size: 10,
      sort_by: "id:desc",
    },
  });
}
